/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminMarketCoverage
 */
export interface AdminMarketCoverage {
    /**
     * EbayListings are the live eBay listings of products in sale.
     * @type {number}
     * @memberof AdminMarketCoverage
     */
    ebayListings: number;
    /**
     * EbayListingsChecked were checked on eBay in the last 24 hours.
     * @type {number}
     * @memberof AdminMarketCoverage
     */
    ebayListingsChecked: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMarketCoverage
     */
    productsInSale: number;
    /**
     * ProductsWithFreshMarket have an eBay market captured in the last 24 hours.
     * @type {number}
     * @memberof AdminMarketCoverage
     */
    productsWithFreshMarket: number;
}

export function AdminMarketCoverageFromJSON(json: any): AdminMarketCoverage {
    return AdminMarketCoverageFromJSONTyped(json, false);
}

export function AdminMarketCoverageFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminMarketCoverage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ebayListings': json['ebayListings'],
        'ebayListingsChecked': json['ebayListingsChecked'],
        'productsInSale': json['productsInSale'],
        'productsWithFreshMarket': json['productsWithFreshMarket'],
    };
}

export function AdminMarketCoverageToJSON(value?: AdminMarketCoverage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ebayListings': value.ebayListings,
        'ebayListingsChecked': value.ebayListingsChecked,
        'productsInSale': value.productsInSale,
        'productsWithFreshMarket': value.productsWithFreshMarket,
    };
}

